<main class="listagem">
    <div class="card card-default">
        <app-support-gridview [config]="config" [templates]="templatesArray" [paginated]="true" [pageSize]="pageSize" [pageIndex]="pageNumberController" [totalItems]="totalHoldings" [hidePageSize]="true" [showFirstLastButtons]="true" (onPageChange)="changePage($event)"></app-support-gridview>

        <ng-template #isBillableTemplate let-item>
            <i-feather [name]="item.isBillable ? 'check' : 'x'" class="icon"></i-feather>
        </ng-template>

        <ng-template #actionTemplate let-item>
            <i-feather [name]="item.isBillable ? 'edit' : 'plus'" class="icon with-action" (click)="selectHoldingToEdit(item)" [tooltip]="'support.manage-holdings.list.actions.' + (item.isBillable ? 'billable' : 'not-billable') | translate"></i-feather>
        </ng-template>
    </div>
</main>
